module.exports = __webpack_public_path__ + "img/bnpl-light.4c07b05.svg";